import { createFileRoute } from '@tanstack/react-router'
import EditionCopyTechnicalProduction from 'Edition/components/sections/Copy/EditionCopyTechnicalProduction'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/copytechnicalproduction')({
    component: EditionCopyTechnicalProduction,
})
